export default __webpack_public_path__ + "img/github.4ffd4fe7.svg";